var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Zm-.92,23a1.005,1.005,0,1,1-2.01,0V10.18l-2.05,1.74a.962.962,0,0,1-.73.23.948.948,0,0,1-.68-.35,1,1,0,0,1,.11-1.41l3.7-3.15a1.034,1.034,0,0,1,1.08-.15,1.017,1.017,0,0,1,.58.91Zm7.2-2.39-3.7,3.15a1.013,1.013,0,0,1-.66.24,1.059,1.059,0,0,1-.42-.09,1.016,1.016,0,0,1-.58-.91V8a1.005,1.005,0,0,1,2.01,0V21.82l2.05-1.74a.99.99,0,0,1,1.41.12.969.969,0,0,1,.24.73.986.986,0,0,1-.35.68Z",
    transform: "translate(-1 -1)",
    fill: "#ef6f6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort_icon.34afbcebed57b0a406c7e38fcad48d55.svg";
export { ForwardRef as ReactComponent };